export enum VideoProvider {
  YouTube = 'youtube',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Tiktok = 'tiktok',
  Vimeo = 'vimeo',
  Dailymotion = 'dailymotion',
  Loom = 'loom',
  Wistia = 'wistia',
  Vidyard = 'vidyard',
  Hippo = 'hippo'
}
